import React, { useState } from "react";
import { FiFileText } from "react-icons/fi";
import { projects } from "./data";
import ProjectModal from "./ProjectModal";

function MissionProjects() {
  const [activeProject, setActiveProject] = useState(null);

  return (
    <section className="ops-section" id="projects">
      <div className="section-heading">
        <p>Mission Logs</p>
        <h2>Case files from labs, systems, and support workflows</h2>
      </div>
      <div className="projects-grid">
        {projects.map((project) => (
          <article className="project-card glass-panel" key={project.name}>
            <div className="case-icon"><FiFileText /></div>
            <span className="status-pill">{project.status}</span>
            <h3>{project.name}</h3>
            <p>{project.summary}</p>
            <div className="tool-row">
              {project.tools.map((tool) => <span key={tool}>{tool}</span>)}
            </div>
            <button type="button" onClick={() => setActiveProject(project)}>
              Open Case File
            </button>
          </article>
        ))}
      </div>
      <ProjectModal project={activeProject} onClose={() => setActiveProject(null)} />
    </section>
  );
}

export default MissionProjects;
